<template>
  <div>
    <div class="auth-area">
      <div class="auth-window auth-window-activate">
        <div class="auth-logo auth-logo-activate">
          <img :src="logoUrl" alt="Widget Brain logo" />
        </div>
        <form
          v-if="correctAccess && !activationSuccess"
          @submit.prevent="activateUser"
          class="auth-form"
        >
          <div class="auth-welcome-text">
            Hi{{ this.firstname ? " " + this.firstname + ", " : ", " }}Welcome
            to Widget Brain. We've set up an account for you to access
            {{ application ? " " + application : "" }}. You just have to pick a
            username and a strong password.
          </div>

          <md-input-container v-bind:class="{ valid: isUsernameValid }">
            <label>Username</label>
            <md-input type="text" v-model="username"></md-input>
          </md-input-container>

          <div v-if="usernameRequirements.length > 0">
            <ul class="errors-list">
              <li
                v-for="(requirement, index) in usernameRequirements"
                :key="index"
              >
                {{ requirement }}
              </li>
            </ul>
          </div>

          <md-input-container
            md-has-password
            v-bind:class="{ valid: isPasswordValid }"
          >
            <label>Password</label>
            <md-input type="password" v-model="password"></md-input>
          </md-input-container>

          <div v-if="passwordRequirements.length > 0">
            <ul class="errors-list">
              <li
                v-for="(requirement, index) in passwordRequirements"
                :key="index"
              >
                {{ requirement }}
              </li>
            </ul>
          </div>

          <md-input-container
            md-has-password
            v-bind:class="{ valid: isPasswordRepeatValid }"
          >
            <label>Repeat password</label>
            <md-input type="password" v-model="passwordRepeat"></md-input>
          </md-input-container>

          <div
            v-if="
              passwordRepeatRequirements &&
              passwordRepeatRequirements.length > 0
            "
          >
            <ul class="errors-list">
              <li
                v-for="(requirement, index) in passwordRepeatRequirements"
                :key="index"
              >
                {{ requirement }}
              </li>
            </ul>
          </div>

          <div class="auth-actions">
            <md-button
              :disabled="
                !isUsernameValid || !isPasswordValid || !isPasswordRepeatValid
              "
              type="submit"
              @submit="activateUser"
              class="md-raised md-primary"
            >
              Activate
            </md-button>
          </div>
          <div class="terms-of-use">
            <p>
              By creating an account, you agree that your personal data will be
              used as follows:
            </p>
            <ul>
              <li>Full Name: application personalisation only;</li>
              <li>
                Username and email: system monitoring and event logging within
                Widget Brain apps.
              </li>
            </ul>
            <p>
              Your personal data will not be shared with third parties outside
              of your organization and Widget Brain. If this invite expires,
              your account details are removed after 7 days.
            </p>
          </div>
        </form>

        <div
          v-if="!correctAccess && !activationSuccess"
          class="auth-welcome-text auth-text-center"
        >
          <p>
            Looks like your Email or Activation key is invalid or expired.
            <br />
            Please contact your Administrator for assistance.
          </p>

          <p>
            We will redirect you to the Login page in
            <span class="highlighted">{{ countDown }}</span> second{{
              countDown > 1 ? "s" : ""
            }}. <br />
            Or click the button bellow to redirect now.
          </p>
          <div class="auth-actions auth-spaced">
            <md-button class="md-raised md-secondary" @click="redirectToALFA">
              Redirect Now
            </md-button>
          </div>
        </div>

        <div
          v-if="correctAccess && activationSuccess"
          class="auth-welcome-text auth-text-center"
        >
          <p>Your account has been activated!</p>
          <p>
            You will be forwarded to ALFA in
            <span class="highlighted">{{ countDown }}</span> second{{
              countDown > 1 ? "s" : ""
            }}. <br />
            Or click the button bellow to redirect now.
          </p>
          <div class="auth-actions auth-spaced">
            <md-button class="md-raised md-secondary" @click="redirectToALFA">
              Redirect Now
            </md-button>
          </div>
        </div>
      </div>
    </div>
    <md-dialog ref="credentialsDialog">
      <md-dialog-title> Credentials </md-dialog-title>
      <md-dialog-content>
        <b>Client ID:</b> {{ clientId }}<br />
        <b>Client Secret:</b> {{ clientSecret }}<br />
      </md-dialog-content>
      <md-dialog-actions>
        <md-button @click="loginUser">Ok</md-button>
      </md-dialog-actions>
    </md-dialog>
  </div>
</template>

<script>
import config from "../helpers/config";
import managedata from "../helpers/managedata";
import logoUrl from "../../images/quinyx-green.svg";
import params from "../helpers/params";

export default {
  name: "Activate",
  data() {
    return {
      correctAccess: true,
      activationSuccess: false,
      countDown: 10,
      logoUrl: logoUrl,
      email: null,
      key: null,
      application: null,
      firstname: null,
      organization: null,
      username: null,
      password: null,
      passwordRepeat: null,
      usernameRequirements: [],
      passwordRequirements: [],
      passwordRepeatRequirements: [],
      isUsernameValid: false,
      isPasswordValid: false,
      isPasswordRepeatValid: false,
      clientId: null,
      clientSecret: null,
    };
  },
  watch: {
    username(val) {
      this.usernameRequirements = [];

      // Min username length should be 8 characters
      if (val.length < 8) {
        this.isUsernameValid = false;
        this.usernameRequirements.push(
          "Username must contain at least 8 characters"
        );
      } else {
        managedata
          .validateUsername(this.email, this.username)
          .then((res) => {
            if (
              res.body.result.requirements &&
              res.body.result.requirements.length > 0
            ) {
              this.usernameRequirements = res.body.result.requirements;
              this.isUsernameValid = false;
            } else {
              this.isUsernameValid = true;
            }
          })
          .catch((err) => {
            this.isUsernameValid = false;
            console.log(err);
          });
      }
    },
    password(val) {
      this.passwordRequirements = [];

      // Min password length should be 8 characters
      if (val.length < 8) {
        this.isPasswordValid = false;
        this.passwordRequirements.push(
          "Password must contain at least 8 characters"
        );
      } else {
        managedata
          .validatePassword(this.password)
          .then((res) => {
            if (
              res.body.result.requirements &&
              res.body.result.requirements.length > 0
            ) {
              this.passwordRequirements = res.body.result.requirements;
              this.isPasswordValid = false;
            } else {
              this.isPasswordValid = true;
            }
          })
          .catch((err) => {
            this.isPasswordValid = false;
            console.log(err);
          });
      }
    },
    passwordRepeat(val) {
      this.passwordRepeatRequirements = [];

      // Min password length should be 8 characters
      if (val.length >= 8) {
        this.isPasswordRepeatValid = this.password === this.passwordRepeat;

        if (!this.isPasswordRepeatValid) {
          this.passwordRepeatRequirements.push("Passwords should match");
        }
      } else {
        this.isPasswordRepeatValid = false;
      }
    },
    countDown: {
      handler(value) {
        if (value > 0) {
          setTimeout(() => {
            this.countDown--;
          }, 1000);
        } else {
          if (!this.correctAccess || this.activationSuccess)
            this.redirectToALFA();
        }
      },
      immediate: true,
    },
  },
  methods: {
    redirectToALFA() {
      let url = params.getParameterValue("ALFA_URL");
      window.open(url, "_self");
    },
    checkActivateKeyEmail() {
      managedata
        .checkActivateKeyEmail(this.email, this.key)
        .then((res) => {
          if (!res.body) {
            this.correctAccess = false;
            this.countDown = 10;
          } else {
            this.correctAccess = true;
            return true;
          }
        })
        .catch((err) => {
          this.correctAccess = false;
          this.countDown = 10;
        });
    },
    getUserDetails() {
      managedata
        .getDescriptionValues(this.email, this.key)
        .then((res) => {
          this.application = res.body.application;
          this.firstname = res.body.firstname;
          this.organization = res.body.organization;
        })
        .catch((err) => {
          this.$store.commit("CLEAR_MESSAGE");
          this.$store.commit({
            type: "SET_MESSAGE",
            message:
              "The key has expired. Please contact WidgetBrain (support@widgetbrain.com / +31103130313) for assistance.",
          });
        });
    },
    activateUser() {
      if (
        !this.isUsernameValid ||
        !this.isPasswordValid ||
        !this.isPasswordRepeatValid
      ) {
        return;
      }

      const newUser = {
        username: this.username,
        password: this.password,
        key: this.key,
        email: this.email,
      };

      managedata
        .activateUser(newUser)
        .then((res) => {
          this.$store.commit("CLEAR_MESSAGE");
          this.$store.commit({
            type: "SET_MESSAGE",
            message: "Activation successful!",
          });

          this.activationSuccess = true;
          this.countDown = 5;

          // const user = {
          //   email: this.email,
          //   password: this.password,
          // };

          // setTimeout(() => {
          //   this.$store
          //     .dispatch("login", {
          //       user,
          //       remember: true,
          //       rememberAll: true,
          //       isExternal: true,
          //     })
          //     .then((res) => {
          //       const message = {
          //         message: "loggedIn",
          //         token: res.body.id,
          //         userId: res.body.userId,
          //         remember: true,
          //       };
          //       this.redirectToALFA();
          //       // window.parent.postMessage(message, "*");
          //     })
          //     .catch((err) => {
          //       console.log("Error: ", err);
          //       if (this.isExternal) {
          //         window.parent.postMessage({ message: "loggedOut" }, "*");
          //       }
          //     });
          // }, 3000);
        })
        .catch((err) => {
          this.$store.commit("CLEAR_MESSAGE");
          this.$store.commit({
            type: "SET_MESSAGE",
            message: err.body.error.message,
          });
        });
    },
    loginUser() {
      this.$refs.credentialsDialog.close();
      // login user
      this.$store
        .dispatch("login", {
          user: {
            email: this.email,
            password: this.password,
          },
          remember: true,
          rememberAll: true,
          isExternal: false,
        })
        .then((res) => {
          this.$store.dispatch("getApps").then(() => {
            const userApps = this.$store.state.apps.filter(
              (app) => app.id !== config.appId
            );
            if (
              userApps.length > 1 ||
              (userApps.length === 1 && userApps[0].url === null)
            ) {
              return this.$store.dispatch("getAssignments");
            }
          });
        })
        .catch((err) => {});
    },
  },
  mounted() {
    this.email = this.$route.query.email;
    this.key = this.$route.query.key;

    if (this.checkActivateKeyEmail()) {
      this.getUserDetails();
    }
  },
};
</script>

<style>
.auth-window.auth-window-activate {
  min-width: 500px;
}

.auth-logo.auth-logo-activate {
  max-width: 400px;
  margin-right: auto;
  margin-left: auto;
}

.auth-welcome-text {
  margin: 40px 0;
  font-weight: 300;
}

.terms-of-use {
  margin-top: 40px;
  font-size: 12px;
  font-weight: 400;
  font-style: italic;
  color: #868686;
}

.errors-list {
  list-style-type: none;
  padding-left: 0;
}

.errors-list li {
  color: red;
}

.md-input-container.valid:after {
  background-color: green !important;
}
.auth-text-center {
  text-align: center;
}
.auth-spaced {
  margin-top: 30px;
}
.auth-welcome-text span.highlighted {
  font-weight: bold;
}
</style>



// WEBPACK FOOTER //
// Activate.vue?45324880